var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-table',_vm._b({attrs:{"no-remove":"","no-actions":!_vm.$can('VIEW_DETAIL_PURCHASE_ORDER')},on:{"detail":_vm.submitDetail}},'r-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }